import { backgroundStreamManager } from './backgroundStreamManager';

/**
 * Initialize global background streams when the app loads
 * This ensures streams persist across component mounts/unmounts
 */
export function initializeGlobalStreams() {
  // Initialize the background stream manager if not already done
  if (!(window as any).__backgroundStreamManager) {
    (window as any).__backgroundStreamManager = backgroundStreamManager;
  }

  // Set up global cleanup listeners
  window.addEventListener('beforeunload', () => {
    backgroundStreamManager.cancelAllStreams();
  });

  console.log('Global background streams initialized');
}
